/* eslint-disable linebreak-style */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable react/jsx-props-no-spreading,import/newline-after-import */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import 'toastr/build/toastr.min';
import React, { Fragment, useEffect } from 'react';
import { AuthProvider } from 'react-auth';
import PropTypes from 'prop-types';
import { ModalProvider } from 'mc-react-redux-modal';
// import App from 'next/app';
import get from 'base-ui/dist/underline/get';
import withGA from 'utils/withGA';
import withFBQ from 'utils/withFBQ';
import withATM from 'utils/withATM';
import * as serviceWorker from 'utils/serviceWorker';
import { init } from 'root/utils/raven';
import Router from 'next/router';
import { MemoryRouter } from 'react-router-dom';
import LocaleProvider from 'components/LocaleProvider';
import GoogleAnalyticsEvent from 'components/GoogleAnalyticsEvent';
import { AdsProvider } from 'components/AdManager/AdsContext';
import metrics from 'utils/service/metrics';
import AmpWrap from 'utils/AmpWrap';
import { BluekaiConfig } from 'components/Scripts';
import { wrapper } from 'state/store';
import { SWRProvider } from 'root/hooks/useAuth';
import UserAgentContext from 'root/utils/withUA/UserAgentContext';
import { Toast } from 'utils/toastConfig';
import Modals from '../containers';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const googleAnalytics = get(publicRuntimeConfig, 'settings.metrics', [publicRuntimeConfig.analytics_id] || [publicRuntimeConfig.GOOGLE_ANALYTICS_ID]);
const fbPixel = get(publicRuntimeConfig, 'settings.metrics', [publicRuntimeConfig.FACEBOOK_PIXEL_ID]);
const adobeTagManager = publicRuntimeConfig.ADOBE_TAG_MANAGER === 'true';

init();
export function reportWebVitals({ id, name, label, value }) {
  metrics({ id, name, label, value });
}

export const Application = (props) => {
  useEffect(() => {
    serviceWorker.register();
  }, []);

  const { Component, pageProps, analytics, fbp } = props;
  return (
    <Fragment>
      <MemoryRouter keyLength={0}>
        <UserAgentContext.Provider value={pageProps?.userAgent}>
          <AuthProvider>
            <AdsProvider>
              <LocaleProvider>
                <Fragment>
                  <AmpWrap nonAmp={<BluekaiConfig />} />
                  <SWRProvider />
                  <Toast />
                  <GoogleAnalyticsEvent analytics={analytics} />
                  <ModalProvider modals={Modals} appElement="#__next">
                    <Component {...pageProps} analytics={analytics} fbp={fbp} />
                  </ModalProvider>
                </Fragment>
              </LocaleProvider>
            </AdsProvider>
          </AuthProvider>
        </UserAgentContext.Provider>
      </MemoryRouter>
    </Fragment>
  );
};

Application.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.object,
  analytics: PropTypes.object,
  fbp: PropTypes.object
};

export default wrapper.withRedux(withATM(adobeTagManager, Router)(withFBQ(fbPixel, Router)(
  withGA(googleAnalytics, Router)(Application),
)));
